import { createReducerFromMap } from "@coverme/redux";

const initialState = {
    wereAssetsGivenAway: undefined,
    referralSource: undefined,
    currentLocation: undefined,
    amountOfTransferredAssets: "",
    isDocumentationOfTransferAvailable: undefined,
    hasClosedAccountsInPast5Years: undefined,
    closedAccountType: "",
    amountReceivedFromClosedAccount: undefined,
    dateOfClosing: "",
    doAssetAccountHaveOtherSignatory: undefined,
    assetAccountSignatoryContactInfo: {},
    doesResidentHavePowerOfAttorney: undefined,
    powerOfAttorneyContactInfo: {},
};

function updateGovernment(state, data) {
    return data.value;
}

function resetInterview(state, action) {
    return initialState;
}

function getInterview(state, action) {
    if (action.value.government) {
        return updateGovernment(state, { value: action.value.government });
    }

    return state;
}

export const governmentReducer = createReducerFromMap(initialState, {
    UPDATE_GOVERNMENT_COMPLETE: updateGovernment,
    RESET_INTERVIEW: resetInterview,
    GET_INTERVIEW_COMPLETE: getInterview,
});
